<template>
  <div>
    <el-form inline>
      <div>
        <el-form-item label="SKU">
          <el-input
            v-model="filters.SKUCode"
            placeholder="请输入SKU"
            clearable
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="采购单号">
          <el-input
            v-model="filters.RelationNumber"
            placeholder="请输入采购单号"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="提货单号">
          <el-input
            v-model="filters.TrackNumber"
            placeholder="请输入提货单号"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="入库单号">
          <el-input
            v-model="filters.SourceNumber"
            placeholder="入库单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="more-search">
            <el-link
              :underline="false"
              @click="showMoreSearch = !showMoreSearch"
              >更多<i
                :class="
                  showMoreSearch
                    ? 'el-icon-arrow-right re90'
                    : 'el-icon-arrow-right re0'
                "
              ></i
            ></el-link>
          </div>
        </el-form-item>
      </div>

      <transition name="el-fade-in-linear" v-if="showMoreSearch">
        <div class="transition-box">
          <el-form-item label="收货单号">
            <el-input
              v-model="filters.PutOnNo"
              placeholder="收货单号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="佰易签收单号">
            <el-input
              v-model="filters.BaiYiSignForNo"
              placeholder="请输入佰易签收单号"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="上架状态">
            <el-select v-model="filters.PutOnStatus" multiple="" collapse-tags>
              <el-option label="待上架" value="10"></el-option>
              <el-option label="部分上架" value="20"></el-option>
              <el-option label="上架完成" value="30"></el-option>
              <el-option label="强制完成" value="40"></el-option>
              <el-option label="废弃" value="50"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门">
            <el-select
              v-model="filters.DepartmentName"
              multiple=""
              collapse-tags
            >
              <el-option
                v-for="item in OrgDepartmentList"
                :label="item.department"
                :value="item.department"
                :key="item.department"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收货完成日期">
            <div class="block">
              <el-date-picker
                v-model="filters.CreateTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>

          <el-form-item label="签收上架完成时效">
            <el-select v-model="filters.SignStockDiffTime" style="width: 60px">
              <el-option
                v-for="item in PutOnStatustList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-model="filters.DayDiffTime"
              placeholder="天"
              clearable
              style="width: 80px"
            ></el-input
            >天
            <el-input
              v-model="filters.HourDiffTime"
              placeholder="小时"
              clearable
              style="width: 80px"
            ></el-input
            >小时
          </el-form-item>
        </div>
      </transition>
    </el-form>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :showResetButton="true"
      @resetBtn="resetBtn"
    ></toolbar>
    <!--列表-->

    <el-table-bar :fixed="true" :bottom="35">
      <el-table
        :data="tablelist"
        highlight-current-row
        border
        ref="multipleTable"
        v-loading="listLoading"
        @selection-change="selsChange"
        @row-click="handleRowClick"
        style="width: 100%"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <!-- <el-table-column prop="rowNum" label="行号"  width="80">
              </el-table-column> -->
        <el-table-column prop="putOnNo" label="收货单号" width="180px">
        </el-table-column>
        <el-table-column prop="skuCode" label="产品Code" width="140px">
        </el-table-column>
        <el-table-column prop="sourceNumber" label="参考信息" width="220px">
          <template slot-scope="scope">
            入库单号：{{ scope.row.sourceNumber }}<br />
            采购单号：{{ scope.row.relationNumber }}<br />
            提货单号：{{ scope.row.trackNumber }}
          </template>
        </el-table-column>
        <el-table-column prop="departmentName" label="部门" width="120px">
        </el-table-column>
        <el-table-column prop="warehouseName" label="仓库" width="120px">
        </el-table-column>

        <el-table-column prop="qty" label="数量信息" width="120px">
          <template slot-scope="scope">
            收货数量:{{ scope.row.qty }}<br />
            上架数量:{{ scope.row.actualPutOnQty }}<br />
          </template>
        </el-table-column>
        <el-table-column prop="isDischarge" label="仓库卸货" width="">
          <template slot-scope="scope">
            {{ scope.row.isDischarge ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="putOnStatusDesc" label="上架状态" width="">
        </el-table-column>

        <el-table-column prop="model" label="装箱信息" width="220px">
          <template slot-scope="scope">
            箱规(cm)：{{ scope.row.boxLength }} *{{ scope.row.boxWidth }} *{{
              scope.row.boxHeight
            }}<br />
            单箱数量：{{ scope.row.singleBoxQty }}<br />
            单箱重量：{{ scope.row.boxWeight }}<br />
            总箱数：{{ scope.row.boxCount }}<br />
          </template>
        </el-table-column>

        <el-table-column prop="material" label="尾箱信息" width="120px">
          <template slot-scope="scope">
            尾箱数量：{{ scope.row.tailBoxPcsQty }}<br />
            尾箱重量：{{ scope.row.tailBoxWeight }}<br />
          </template>
        </el-table-column>
        <el-table-column prop="palletMark" label="托唛" width="100px">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.fileUrl != '' && scope.row.fileUrl != null">
                <el-link
                  style="margin-left: 5px"
                  :underline="false"
                  type="primary"
                  @click.native="DownloadProductSKUAttachBtn(scope.row)"
                >
                  下载
                </el-link>
              </span>
              <br />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="操作人" width="160px">
          <template slot-scope="scope">
            签收人:{{ scope.row.createUser }}<br />
            上架人:{{ scope.row.putStockUser }}<br />
          </template>
        </el-table-column>

        <el-table-column prop="createUser" label="图片" width="100px">
          <template slot-scope="scope">
            <el-link
              type="primary"
              v-if="scope.row.twSignForID != 0"
              @click="getImage(scope.row.twSignForID)"
              >查看</el-link
            >
          </template>
        </el-table-column>

        <el-table-column prop="hsCode" label="签收上架完成时效" width="140px">
          <template slot-scope="scope">
            <el-button click="" type="text" size="small"
              >{{ scope.row.signStockDiffTimeDesc }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="时间信息" width="220px">
          <template slot-scope="scope">
            创建时间：{{ scope.row.createTimeDesc }}<br />
            完成收货：{{ scope.row.createTimeDesc }}<br />
            完成上架：{{ scope.row.overPutStockTimeDesc }}<br />
          </template>
        </el-table-column>

        <el-table-column prop="baiYiSignForNo" label="佰易签收单" width="140px">
        </el-table-column>

        <el-table-column prop="baiYiAPIMsg" label="佰易异常信息" width="140px">
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="getbusinessLoglist(scope.row)"
              type="text"
              size="small"
              >日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-size="50"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>

    <!-- SKU打印 -->
    <el-dialog
      :visible.sync="skuFormVisible"
      v-model="skuFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="打印SKU二维码"
    >
      <el-form>
        <el-row v-for="(item, index) in skuForm" :key="index">
          <el-col :span="24"
            ><span>{{ item.skushow }}</span>
            <span>，打印</span>
            <el-input-number
              v-model="item.boxCount"
              auto-complete="off"
              placeholder="请输入打印数量"
              :min="1"
              :max="100"
              onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input-number>
            <span>&nbsp;&nbsp;&nbsp;&nbsp; 张</span></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24"
            ><span style="color: red">一次打印请勿超过100张哦</span>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click.native="skuFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onSubmitsku" :loading="skuLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="修改箱规"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="skuCode" class="labelcall" label-width="120px">
              {{ editForm.skuCode }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="名称"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              {{ editForm.productNameCN }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="长cm"
              prop="boxLength"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.boxLength"
                auto-complete="off"
                placeholder="长cm"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="boxWidth"
              label="宽cm"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="editForm.boxWidth"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="boxHeight"
              label="高cm"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="editForm.boxHeight"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="单箱重量(kg)"
              prop="boxWeight"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.boxWeight"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="单箱数量"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              {{ editForm.singleBoxQty }}
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              label="件数"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              {{ editForm.completeBoxCount }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="尾箱数量"
              prop="tailBoxPcsQty"
              class="labelcall"
              label-width="120px"
            >
              {{ editForm.tailBoxPcsQty }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="tailBoxWeight"
              label="尾箱重量(kg)"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              <el-input
                v-model="editForm.tailBoxWeight"
                auto-complete="off"
                placeholder="50字符以内"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              prop="qty"
              label="收货数量"
              class="labelcall"
              label-width="120px"
              style="width: 100%"
            >
              {{ editForm.qty }}
            </el-form-item>
          </el-col>
        </el-row>

        <div>
          <el-row
            style="text-align: right; margin-top: 20px; margin-right: 20px"
          >
            <el-col :span="24">
              <el-form-item>
                <el-button @click="editFormVisible = false">关闭</el-button>
                <el-button
                  type="primary"
                  :loading="editLoading"
                  @click="editSubmit()"
                  >修改</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{ businessType: 11, businessCode: this.currentRow.putOnNo }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <div>
      <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
        <img v-for="(src, index) in srcList" :src="src" :key="index" />
      </viewer>
    </div>

    <!-- <el-image
      v-if="showPreviewImg"
      style="width: 100px; height: 100px; position: absolute; right: -5000px"
      id="ImgEle"
      :src="srcList[0]"
      :preview-src-list="srcList"
    >
    </el-image> -->
    <createQualityList
      ref="createQualityListRef"
      :sourceType="10"
      @searchTable="GetReceiveManageList"
    />
  </div>
</template>

<script>
import util from "../../../util/date";
import LogDialog from "../../components/TwTable/components/logDialog";
import {
  GetReceiveManageList,
  getDepartmentList,
  UpdatePutOnBoxInfo,
  ReceiveManageExport,
  SynchroBaiYiSignForNo,
  printDeliveryInfoSku,
  OverPutOn,
} from "@/api/ReceiveManage.js";
import { getSignForImage } from "@/api/mobile/signIn_api";
import { getButtonList } from "../../promissionRouter";
import axios from "axios";
import Toolbar from "../../components/Toolbar";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import createQualityList from "../QCCheck/components/createQualityList.vue";
export default {
  components: { Toolbar, LogDialog, createQualityList },
  mixins: [TwTable_mixins],
  data() {
    var changdu = (rule, value, callback) => {
      const reg = /^\d+.?\d{0,1}$/;
      if (!value) {
        callback(new Error("请输入数字"));
      } else if (!Number(value)) {
        callback(new Error("请输入数字值"));
      } else if (parseFloat(value).toFixed(2) > 9999999.9) {
        callback(new Error("最大值为9999999.9"));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("小数点后最多只能输入1位"));
        }
      }
    };

    var price = (rule, value, callback) => {
      const reg = /^\d+.?\d{0,2}$/;
      if (!value) {
        callback(new Error("请输入数字"));
      } else if (!Number(value)) {
        callback(new Error("请输入数字值"));
      } else if (parseFloat(value).toFixed(2) > 9999999.99) {
        callback(new Error("最大值为9999999.99"));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("小数点后最多只能输入2位"));
        }
      }
    };

    var numberlimit0 = (rule, value, callback) => {
      const reg = /^\d+.?\d{0,3}$/;

      if (value == 0) {
        callback();
      } else if (!value) {
        callback(new Error("请输入数字"));
      } else if (!Number(value)) {
        callback(new Error("请输入数字值"));
      } else if (parseFloat(value).toFixed(2) > 9999999.99) {
        callback(new Error("最大值为9999999.99"));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("小数点后最多只能输入3位"));
        }
      }
    };

    var numberlimit = (rule, value, callback) => {
      const reg = /^\d+.?\d{0,3}$/;
      if (!value) {
        callback(new Error("请输入数字"));
      } else if (!Number(value)) {
        callback(new Error("请输入数字值"));
      } else if (parseFloat(value).toFixed(2) > 9999999.99) {
        callback(new Error("最大值为9999999.99"));
      } else {
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("小数点后最多只能输入3位"));
        }
      }
    };
    return {
      editFormVisible: false, //编辑界面是否显示
      skuFormVisible: false,
      Importtext: "", //导入返回信息
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      customerList: [],
      skuForm: [],
      skuLoading: false,
      searchConsumerVisible: false,
      filters: { PutOnBoxDetailIDs: [], PutOnInfoIDs: [] },
      buttonList: [],
      typeVisible: false,
      fileList: [],
      flag: false,
      sels: [], //列表选中列
      showMoreSearch: false,
      validation: true,
      tablelist: [],
      editFormRules: {
        boxLength: [{ required: true, validator: changdu, trigger: "blur" }],
        boxWidth: [{ required: true, validator: changdu, trigger: "blur" }],
        boxHeight: [{ required: true, validator: changdu, trigger: "blur" }],
        boxWeight: [
          { required: true, validator: numberlimit, trigger: "blur" },
        ],
        tailBoxWeight: [
          { required: true, validator: numberlimit0, trigger: "blur" },
        ],
      },
      PutOnStatustList: [
        {
          value: 1,
          label: ">",
        },
        {
          value: 0,
          label: "=",
        },
        {
          value: -1,
          label: "<",
        },
      ],
      editForm: {},
      editLoading: false,
      listLoading: false,
      currentRow: null,
      OrgDepartmentList: [],
      total: 0,
      page: 1,
      pageSize: 50,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      showPreviewImg: false,
      srcList: [],
    };
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    // 新增质检
    create() {
      // 收货完成才能创建
      const rows = this.sels;
      if (rows.length !== 1) {
        this.$message({
          message: "请勾选一条数据",
          type: "error",
        });
        return;
      }
      let status = [20, 30, 40];
      if (!status.includes(rows[0].putOnStatus)) {
        this.$message({
          message: "请选择[部分上架][上架完成][强制完成]单据",
          type: "error",
        });
        return;
      }
      this.$refs.createQualityListRef.showDalog(rows[0]);
    },
    //下载托唛
    DownloadProductSKUAttachBtn(file) {
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      window.open(file.fileUrl, "_blank");

      loading.close();
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      let row = this.sels;
      row.forEach((item) => {
        this.filters.PutOnBoxDetailIDs.push(item.putOnBoxDetailID);
      });

      ReceiveManageExport(this.filters).then((res) => {
        loading.close();
        if (res.data.success) {
          var data = res.data.response;
          if (data != null) {
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });

          return;
        }
      });
    },
    //回滚
    OverPutOn() {
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }

      this.$confirm("确认回滚单据吗？?", "提示", {
        type: "warning",
      }).then(() => {
        let row = this.sels;

        var para = [];
        var flagStatus = true;
        row.forEach((item) => {
          para.push({
            PutOnInfoID: item.putOnInfoID,
            PutOnStatus: item.putOnStatus,
            BaiYiSignForNo: item.baiYiSignForNo,
            PutOnBoxInfoID: item.putOnBoxInfoID,
          });
        });

        const loading = this.$loading({
          lock: true,
          text: "加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)",
        });
        OverPutOn(para).then((res) => {
          loading.close();
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });

            this.GetReceiveManageList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    SynchroBaiYiSignForNo() {
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      let row = this.sels;
      var para = [];
      var flagStatus = true;
      var baiyiStatus = true;

      var putOnStatusArray = [30, 40];

      row.forEach((item) => {
        if (putOnStatusArray.indexOf(item.putOnStatus) < 0) {
          flagStatus = false;
        }

        if (item.baiYiSignForNo != null && item.baiYiSignForNo != "") {
          baiyiStatus = false;
        }
        para.push({
          PutOnInfoID: item.putOnInfoID,
          PutOnStatus: item.putOnStatus,
          BaiYiSignForNo: item.baiYiSignForNo,
        });
      });
      debugger;
      if (!flagStatus) {
        this.$message({
          message: "请选择上架完成或者强制完成的单据",
          type: "error",
        });
        return;
      }
      if (!baiyiStatus) {
        this.$message({
          message: "请选择未同步佰易的数据",
          type: "error",
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "同步中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      SynchroBaiYiSignForNo(para).then((res) => {
        loading.close();
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });

          this.GetReceiveManageList();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    handlePintSKU() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要打印的数据！",
          type: "error",
        });
        return;
      }
      this.skuForm = [];
      row.forEach((item) => {
        let skurow = {
          sku: item.skuCode,
          skushow: item.skuCode + "（" + item.productNameCN + ")",
          boxCount: item.boxCount,
          productNameCN: item.productNameCN,
        };
        this.skuForm.push(skurow);
      });
      this.skuFormVisible = true;
    },

    //打印
    onSubmitsku() {
      let row = this.skuForm;
      row.forEach((item) => {
        if (
          item.boxCount == 0 ||
          item.boxCount == "" ||
          item.boxCount == null
        ) {
          this.$message({
            message: item.skushow + "打印数量错误，请修改",
            type: "error",
          });
          return;
        }
      });
      let para = Object.assign([], row);
      this.skuLoading = true;

      const loading = this.$loading({
        lock: true,
        text: "打印中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      printDeliveryInfoSku(para).then((res) => {
        this.skuLoading = false;
        loading.close();
        if (res.data.success) {
          window.open(res.data.response, "_blank");
          this.skuFormVisible = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
      this.$refs.multipleTable.toggleRowSelection(val);
    },

    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },
    //获取接口列表
    GetReceiveManageList(item) {
      this.filters.PutOnBoxDetailIDs = [];
      toString.call(item) === "[object Object]" ? (this.page = 1) : this.page;
      // this.filters.page=this.page;
      // this.filters.pageSize=this.pageSize;
      this.listLoading = true;

      this.newfilters.page = this.page;
      this.newfilters.pageSize = this.pageSize;
      GetReceiveManageList(this.newfilters).then((res) => {
        this.total = res.data.response.total;
        this.tablelist = res.data.response.pageData;
        this.listLoading = false;
      });
    },
    callFunction(item) {
      // this.filters = {
      //     keyword: item.search
      // };
      // this[item.func].apply(this, item);
      this.newfilters = JSON.parse(JSON.stringify(this.filters));
      this[item.func].apply(this, [item]);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetReceiveManageList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.GetReceiveManageList();
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    getDepartmentList() {
      var para = { orgID: 0 };

      let user = JSON.parse(window.localStorage.user);
      getDepartmentList({ orgId: user.organizationId }).then((res) => {
        this.OrgDepartmentList = res.data.response;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = {};

      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }

      if (this.sels != null && this.sels.length === 1) {
        row = this.sels[0];
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }

      if (row.putOnStatus == 30 || row.putOnStatus == 50) {
        this.$message({
          message: "上架完成和废弃状态的收货单，不能够修改箱规",
          type: "error",
        });

        return;
      }
      this.editForm = Object.assign({}, row);
      console.log(JSON.stringify(this.editForm));

      this.editFormVisible = true;
      //this.$refs.editForm.clearValidate();

      this.$nextTick(() => {
        this.$refs["editForm"].clearValidate();
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            UpdatePutOnBoxInfo(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.GetReceiveManageList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            });
          });
        }
      });
    },

    getImage(id) {
      const data = {
        signForID: id,
      };
      this.showPreviewImg = false;
      this.srcList = [];

      const loading = this.$loading({
        lock: true,
        text: "图片加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      getSignForImage(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.showPreviewImg = true;
          const { response } = res;
          response.forEach((item, i) => {
            response[i] = `data:image/png;base64,${item}`;
          });

          this.srcList = response;
          this.$viewer.view(0);
          this.$viewer.show();
          // setTimeout(function(){
          //   document.querySelector('#ImgEle').click()
          // },500)
        } else {
          this.$message({
            message: "加载失败！",
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    this.filters.SignStockDiffTime = 1;
    this.getDepartmentList();
    // this.GetReceiveManageList();

    let user = JSON.parse(window.localStorage.user);
    console.info(user);
    this.typeVisible = user.isSa;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.re90 {
  transform: rotateZ(90deg);
  transition: all 0.5s;
}
.re0 {
  transform: rotateZ(0deg);
  transition: all 0.5s;
}
</style>